import routeConfige from "../../../../app/providers/router/config";
import useAppRoutes from "../../../../shared/hooks/useAppRoutes";
import AppNavLink from "../AppNavLink/AppNavLink";
import styles from './NavbarMobile.module.scss';

const NavbarMobile = () => {
    const includeIcons = true;
    const routes = useAppRoutes({routeConfige, includeIcons});

    return ( 
        <div className={styles.container}>
            <nav className={styles.navbar}>
                {
                    routes.map(route => (
                        <AppNavLink
                            key={route.path}
                            route={route}
                            styles={styles}
                            isDefaultStyle={true}
                        />
                    ))
                }
            </nav>
        </div>
    );
}

export default NavbarMobile;